import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export interface UserDetails {
  id: string;
  [key: string]: any;
}

const REGISTRY_API_URL = process.env.REACT_APP_REGISTRY_API_URL || "";

export const registryUserApi = createApi({
  reducerPath: "registryUserApi",
  baseQuery: fetchBaseQuery({
    baseUrl: REGISTRY_API_URL,
  }),
  tagTypes: ["RegistryUser"],
  endpoints: (build) => ({
    getRegistryUserDetails: build.query<UserDetails, string>({
      query: (id) => `/rs/registry/userdetails/${id}`,
      providesTags: ["RegistryUser"],
    }),

  }),
});

export const { useGetRegistryUserDetailsQuery } = registryUserApi;
